import styled from "styled-components";
import folha1 from "../../assets/icons/folha1.png";

export const MainContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center; /* Centraliza horizontalmente */
  justify-content: flex-start; /* Alinha no topo */
  width: 100%;
  min-height: 100vh;
  background: var(--app-bg-gradient);
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;
  padding: 2rem 0; /* Adiciona padding vertical */
`;

// Wrapper do conteúdo
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HeaderSection = styled.header`
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 2rem 0;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;


export const FormContainer = styled.form`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1.5em;
  border-radius: 20px;
  box-shadow: var(--shadow-md);
  z-index: 2;
  background: var(--surface-glass);
  border: 1px solid var(--border-subtle);
  backdrop-filter: blur(20px);
  width: ${({ collapsed }) => (collapsed ? "70vw" : "70vw")};
  margin: auto;
  margin-top: 4vh;
  margin-bottom: 4vh;
  position: relative;
  overflow: hidden;
  min-height: 600px;
  margin-bottom: 4vh;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: 100% !important;
    max-width: 100%;
    min-height: auto;
    margin-top: 3.25rem;
    padding: 1rem;
    box-sizing: border-box;
  }
`;

export const FirstRow = styled.div`
  display: flex;
  flex-direction: row; /* Mudar de column para row */
  align-items: center; /* Alinhar verticalmente ao centro */
  justify-content: space-between; /* Espaço entre título e botão */
  width: 100%;
  margin-bottom: 3vh;
`;

export const Subtitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 400;
  color: var(--text-heading);
  margin: 0;
  letter-spacing: 0.05em;
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.26vw;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.26vw;
  width: 50%;

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    box-sizing: border-box;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 3vh;
`;

export const Label = styled.label`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0.5rem;
  display: block;
  position: relative;
  z-index: 2;
`;

export const ShowInput = styled.input`
  width: 23vw;
  height: 1.2vw;
  padding: 0.8vw 0.8vw;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    height: auto !important;
    min-height: 44px;
    padding: 0.7rem 0.85rem !important;
    font-size: 16px;
    box-sizing: border-box;
  }
`;

export const StyledSelect = styled.select`
  width: 25vw;
  height: 3vw;
  padding: 0.8vw 0.8vw;
  padding-right: 50px; // Aumenta o espaço para a seta + margem
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  position: relative;
  z-index: 2;
  
  // Remove as propriedades de direção RTL
  text-align: left;
  direction: ltr;

  // Custom arrow (seta personalizada) na direita com margem
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='rgba(219, 251, 142, 0.7)'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 20px center; // Seta na direita com margem
  background-size: 20px;

  option {
    background: var(--surface-overlay);
    color: var(--text-primary);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    padding-right: 45px;
    background-position: right 15px center;
  }
`;

export const Divider = styled.hr`
  width: 100%;
  height: 1px;
  background-color: var(--border-default);
  border: none;
  margin: 24px 0;
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  position: relative;
  z-index: 2;
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center; 
  width: 100%;
  position: relative;
  z-index: 2;
`;

export const Input = styled.input`
  appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-strong);
  border-radius: 50%;
  background: var(--input-bg);
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  margin-right: 12px;

  &:checked {
    background: var(--accent);
    border-color: var(--accent-secondary);
    box-shadow: 0 0 0 2px var(--accent-soft);
  }

  &:checked::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--accent-secondary);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  &:hover:not(:checked) {
    border-color: var(--border-strong);
    background: var(--input-bg-focus);
  }
`;

export const RadioLabel = styled.label`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center; 
  cursor: pointer;
  flex: 1;
  `;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  z-index: 2;
  gap: 2rem; /* Espaço entre os checkboxes */
`;

export const CheckboxRow = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center; /* Alinha verticalmente */
  gap: 0.5rem; /* Espaço entre checkbox e texto */
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
  white-space: nowrap; /* Impede a quebra de linha */

  &:hover {
    color: var(--accent-secondary);
  }
`;

export const LabelText = styled.span`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  transition: all 0.3s ease;
  white-space: nowrap; /* Impede a quebra de linha */

  &:hover {
    color: var(--accent-secondary);
    text-decoration: none;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0; /* Impede que o checkbox diminua */
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;
`;

export const StyledCheckbox = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-strong);
  border-radius: 4px;
  background: var(--input-bg);
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; /* Impede que o checkbox diminua */

  ${props => props.checked && `
    background: var(--accent);
    border-color: var(--accent-secondary);
    box-shadow: 0 0 0 2px var(--accent-soft);
  `}

  &:hover {
    border-color: var(--border-strong);
    background: var(--input-bg-focus);
  }

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  ${props => props.checked && `
    &::after {
      content: '✓';
      color: var(--accent-secondary);
      font-size: 14px;
      font-weight: bold;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  `}
`;

// Componente de erro
export const ErrorForm = styled.div`
  color: var(--danger);
  font-size: 12px;
  font-weight: 500;
  margin-top: 0.25rem;
  padding-left: 2rem;
  white-space: nowrap;
`;

//askldasdlkashdlasd


export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  width: 80%;

  ${ShowInput} {
    flex: 1;
    min-width: 0;
    width: auto;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const BtnShowPassword = styled.button`
  flex-shrink: 0;
  background-color: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const ProfileContainerInfo = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.5em;
  border-radius: 20px;
  box-shadow: var(--shadow-sm);
  z-index: 2;
  background: var(--surface-1);
  border: 1px solid var(--border-subtle);
  width: ${({ collapsed }) => (collapsed ? "47vw" : "47vw")};
  margin: auto;
  margin-top: 50px;
  position: relative;
  overflow: hidden;
  min-height: 600px;

  h3 {
    display: flex;
    align-self: flex-start;
    color: var(--text-heading);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    margin-top: 3.25rem;
    box-sizing: border-box;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 10;
    width: 900px;
    height: 1100px;
    background-image: url(${folha1});
    background-size: auto 100%;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 0.15;
    z-index: -1;
    pointer-events: none;
  }
`;

/**
 * export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  width: 100%;
  margin-top: 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;
 */


export const Span = styled.span`
  font-weight: bold;
  color: var(--text-primary);
`;

export const ErrorText = styled.p`
  margin-top: 0.25rem; /* mt-1 */
  font-size: 0.75rem; /* text-xs */
  color: var(--danger); /* text-red-400 */
  min-height: 1rem; /* min-h-[1rem] */
`;

/** Página ENG — largura total, alinhada ao shell Usuários/Projetos. */
export const FieldUserPage = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 1.25rem 1.25rem 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  min-height: 100%;

  @media (max-width: 768px) {
    padding: 1rem 0.75rem 2rem;
  }
`;

/** Formulário ENG PROP/GUARDIAN — painel em largura total. */
export const FieldUserCard = styled.div`
  width: 100%;
  max-width: none;
  margin: 0 0 1.5rem;
  padding: 1.35rem 1.35rem 1.5rem;
  border-radius: 14px;
  border: 1px solid var(--border-default);
  background: var(--surface-1, var(--input-bg));
  box-shadow: none;
  box-sizing: border-box;
  position: relative;
  z-index: 2;

  @media (max-width: 768px) {
    padding: 1.1rem 1rem 1.25rem;
    border-radius: 12px;
  }
`;

export const FieldUserForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: 0;

  ${Label} {
    width: 100%;
    margin-bottom: 0.4rem;
  }

  ${ShowInput},
  ${StyledSelect} {
    width: 100%;
    max-width: 100%;
    min-height: 44px;
    height: 44px;
    padding: 0.75rem 1rem;
    box-sizing: border-box;
    font-size: 14px;
  }

  ${StyledSelect} {
    padding-right: 2.5rem;
    background-position: right 12px center;
    background-size: 18px;
  }

  & [class*="Error"],
  & ${Row} > div {
    padding-left: 0;
    white-space: normal;
  }
`;

export const FieldUserFields = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem 1.5rem;
  width: 100%;

  ${Row} {
    width: 100%;
    margin: 0;
    align-items: stretch;
    flex-direction: column;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 0.9rem;
  }
`;

export const FieldUserAreaBlock = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  width: 100%;

  .area-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 0.65rem;
    align-items: center;

    ${StyledSelect} {
      flex: 1 1 220px;
      min-width: 180px;
    }
  }

  .area-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;

    span {
      display: inline-flex;
      align-items: center;
      gap: 0.35rem;
      padding: 0.3rem 0.65rem;
      border-radius: 999px;
      background: color-mix(in srgb, var(--accent, #3dd6c6) 18%, transparent);
      font-size: 0.85rem;
      color: var(--text-primary);
    }

    button {
      border: none;
      background: transparent;
      cursor: pointer;
      font-size: 1rem;
      line-height: 1;
      padding: 0;
      color: var(--text-secondary);
    }
  }

  .area-empty {
    color: var(--danger);
    font-size: 0.9rem;
  }
`;

export const FieldUserTitle = styled.h1`
  color: var(--text-heading);
  font-size: clamp(1.1rem, 2vw, 1.35rem);
  font-weight: 700;
  line-height: 1.35;
  margin: 0 0 0.35rem;
  text-align: left;
`;

export const FieldUserHint = styled.p`
  margin: 0 0 1rem;
  color: var(--text-muted, var(--text-secondary));
  font-size: 0.95rem;
  line-height: 1.5;
  max-width: 72ch;
`;

export const FieldUserEmailNotice = styled.div`
  margin: 0 0 1.35rem;
  padding: 0.95rem 1.1rem;
  border-radius: 12px;
  border: 1px solid var(--border-default);
  background: var(--accent-soft, rgba(0, 176, 86, 0.08));
  color: var(--text-primary);
  font-size: 0.875rem;
  line-height: 1.5;

  strong {
    display: block;
    margin-bottom: 0.4rem;
    color: var(--text-heading);
    font-size: 0.9rem;
  }

  ul {
    margin: 0;
    padding-left: 1.15rem;
    columns: 1;

    @media (min-width: 900px) {
      columns: 2;
      column-gap: 2rem;
    }
  }

  li {
    margin: 0.25rem 0;
    break-inside: avoid;
  }
`;

export const FieldUserActions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  width: 100%;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-default);

  @media (max-width: 640px) {
    flex-direction: column-reverse;
    justify-content: stretch;

    > * {
      width: 100%;
    }
  }
`;
